import React, { Component } from 'react';
import { Layout, Dropdown, Menu, Icon, Button, Popover, Alert } from 'antd';
import styles from './styles.module.scss';
import { PersonFormDrawer } from '../People';
import countries from '../../utils/countryCodes';
import memoize from 'memoize-one';
import People from '../components';
import cw from '../../utils/commonwords';
import { FormattedMessage } from 'react-intl';
import { HeaderInfo } from './HeaderInfo';
import { GroupSearch } from '../GroupSearch';
import SubGroupsFilter from './SubGroupsFilter';
import { UploadPeople } from '@/components/People';
import { API_URL } from '@/config/environment';
import { getCookie } from '@/utils/helpers';
import axios from 'axios';
export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addPersonDrawerVisible: false,
      addPersonDrawerPlacement: 'right',
      importPeopleModalVisible: false,
      downloadAlert: false,
      downloadMessage: '',
    };

    this.downloadList = this.downloadList.bind(this);
  }

  handleAddPersonBtnClick = () => {
    this.setState((state, props) => ({
      addPersonDrawerVisible: true,
    }));
  };

  handleAddPersonDrawerClose = () => {
    this.setState((state, props) => ({
      addPersonDrawerVisible: false,
    }));
  };
  handleShowImportPeopleModalButtonClick = () => {
    this.setState(prevState => ({
      importPeopleModalVisible: true,
    }));
  };
  handleCloseImportPeopleModalButtonClick = () => {
    this.setState(prevState => ({
      importPeopleModalVisible: false,
    }));
  };
  personDrawerFormRef = personFormRef => {
    this.personFormRef = personFormRef;
  };
  handlePersonAdd = () => {
    const form = this.personFormRef.props.form;
    const { onAddPerson } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      onAddPerson(values);
    });
  };
  handleUploadPeopleFromFile = confirm => {
    const form = this.importPeopleForm.props.form;

    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      if (confirm) {
        const data = { fileName: this.props.fileName };
        if (values.groupId) data.groupId = values.groupId;
        this.props.uploadPeopleFromFileConfirm(data);
      } else {
        const file =
          values &&
          values.upload &&
          values.upload[0] &&
          values.upload[0].originFileObj
            ? values.upload[0].originFileObj
            : null;

        this.props.uploadPeopleFromFile(file);
      }
    });
  };
  importPeopleFormRef = importPeopleForm => {
    this.importPeopleForm = importPeopleForm;
  };

  addPersonDrawerVisiblility = (personAdded, addPersonDrawerVisible) => {
    if (personAdded) {
      this.setState((state, props) => ({
        addPersonDrawerVisible: false,
      }));
      return false;
    } else {
      return addPersonDrawerVisible;
    }
  };

  downloadList() {
    const user = JSON.parse(getCookie('user'));
    const groupId = this.props.fetchedGroupId || user.account_id;
    const url = `/account-profiles/${groupId}/?email=${user.email}`;
    axios({
      method: 'GET',
      url: `${API_URL}${url}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`,
      },
    }).then(res => {
      this.setState(() => ({
        downloadAlert: true,
        downloadMessage: res.data,
      }));

      // setTimeout(function(){
      //   this.setState(()=> ({downloadAlert: false}))
      // },5000)
    });
  }

  memoizedAddPersonDrawerVisiblility = memoize(this.addPersonDrawerVisiblility);
  render() {
    const {
      width,
      addingPerson,
      screen,
      pageTitle,
      groups,
      personAdded,
      fetchedGroupId,
      fetchingPerson,
      uploadedPeople,
      uploadingPeopleFromFile,
      peopleUploaded,
      uplodPeopleError,
      siteLanguage,
      location,
      numberOfPeople,
      numberOfGroupPeople,
      totalNumberOfPeople,
      currentGroup,
      intl,
      query,
      totalNumberOfGroupPeople,
      subGroups,
      parentGroupName,
    } = this.props;
    const { addPersonDrawerVisible, importPeopleModalVisible } = this.state;

    const showPersonDrawer = this.memoizedAddPersonDrawerVisiblility(
      personAdded,
      addPersonDrawerVisible
    );

    return (
      <Layout.Header
        style={{
          position: 'fixed',
          zIndex: 2,
          width,
          padding: 0,
          marginTop: 65,
        }}
      >
        <div className={styles.Header}>
          <HeaderInfo
            intl={intl}
            siteLanguage={siteLanguage}
            className={styles.HeaderInfo}
            currentGroup={currentGroup}
            parentGroupName={parentGroupName}
            totalNumberOfPeople={totalNumberOfPeople}
            location={location}
            numberOfPeople={numberOfPeople}
            numberOfGroupPeople={numberOfGroupPeople}
            totalNumberOfGroupPeople={totalNumberOfGroupPeople}
            query={query}
            pageTitle={pageTitle}
          />
          <div className={styles.HeaderContent}>
            <div className={styles.headerSearch}>
              <People.SearchBar
                initialValue={query}
                siteLanguage={siteLanguage}
                location={location}
              />
              {`${location.pathname}`.includes('/groups/') &&
                (currentGroup.groupType === 'system' ||
                  currentGroup.parentId) && (
                  <SubGroupsFilter
                    subGroups={subGroups}
                    currentGroup={currentGroup}
                    fetchedGroupId={fetchedGroupId}
                  />
                )}
            </div>
            {(`${location.pathname}`.includes('/groups/') &&
              [parentGroupName, currentGroup.groupName].includes('Agents')) ===
              false && (
              <div className={styles.headerButtons}>
                <Dropdown.Button
                  onClick={this.handleAddPersonBtnClick}
                  type='primary'
                  icon={<Icon type='down' />}
                  overlay={
                    <Menu
                      onClick={e => {
                        if (e.key === 'single') {
                          this.handleAddPersonBtnClick();
                        } else if (e.key === 'file') {
                          this.handleShowImportPeopleModalButtonClick();
                        }
                      }}
                    >
                      <Menu.Item key='file'>
                        <FormattedMessage
                          id='App.ImportFromFile'
                          defaultMessage={'Import from a file'}
                        />
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                >
                  <FormattedMessage
                    id='App.AddPerson'
                    defaultMessage={'Add person'}
                  />
                </Dropdown.Button>

                <Button
                  onClick={this.downloadList}
                  title='Download list'
                  type='secondary'
                  icon='download'
                />
                {/* <HeaderUserDropdown signOutUser={signOutUser} intl={intl} /> */}
              </div>
            )}
          </div>
        </div>
        <UploadPeople
          location={location || { pathname: '' }}
          fetchedGroupId={fetchedGroupId}
          visible={importPeopleModalVisible}
          onClose={this.handleCloseImportPeopleModalButtonClick}
        />
        {/*<People.ImportPeopleModal*/}
        {/*  // visible={importPeopleModalVisible}*/}
        {/*  handleClose={this.handleCloseImportPeopleModalButtonClick}*/}
        {/*  handleOk={this.handleUploadPeopleFromFile}*/}
        {/*  wrappedComponentRef={this.importPeopleFormRef}*/}
        {/*  uploadedPeople={uploadedPeople}*/}
        {/*  uploadingPeopleFromFile={uploadingPeopleFromFile}*/}
        {/*  peopleUploaded={peopleUploaded}*/}
        {/*  uplodPeopleError={uplodPeopleError}*/}
        {/*  fetchedGroupId={fetchedGroupId}*/}
        {/*  location={location || { pathname: "" }}*/}
        {/*/>*/}

        <PersonFormDrawer
          location={location}
          intl={intl}
          drawerTitle={this.props.intl.formatMessage(cw['NewPerson'])}
          wrappedComponentRef={this.personDrawerFormRef}
          width={
            screen !== 'screen-xxl'
              ? screen === 'screen-md'
                ? '50%'
                : screen === 'screen-sm' || screen === 'screen-xs'
                ? '80%'
                : '35%'
              : '25%'
          }
          onOk={this.handlePersonAdd}
          onCancel={this.handleAddPersonDrawerClose}
          visible={showPersonDrawer}
          okButtonProps={{
            loading: addingPerson,
            'data-dfs-people-id': 'person-add-form-drawer-add-button',
          }}
          countries={countries}
          myGroups={groups}
          mode='create'
          fetchedGroupId={
            currentGroup.groupType === 'system' ? undefined : fetchedGroupId
          }
          fetchingPerson={fetchingPerson}
        />
      </Layout.Header>
    );
  }
}

export default Header;
